import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-appointments-policy',
  templateUrl: './appointments-policy.component.html',
  styleUrl: './appointments-policy.component.scss'
})
export class AppointmentsPolicyComponent {
  public companyName: string = environment.company;
  public contactEmail: string = environment.emails.contact_email;
}
